import React from 'react'
import styled from 'styled-components'
import { default as header1 } from '../../assets/img1.png'
import { motion } from 'framer-motion'

const Header = () => {
  return (
    <HeaderContainer>
      <HeaderTitle as={motion.div} variants={{
        hidden: {opacity: 0, y: 75},
        visible: {opacity: 1, y: 0},
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 1, delay: 0.5 }}
      >
        Your Trusted Partner in 
        <HeaderTitleHighlight as={motion.div} variants={{
            hidden: {opacity: 0, y: 75},
            visible: {opacity: 1, y: 0},
          }}
          initial="hidden"
          animate="visible"
          transition={{ duration: 1, delay: 0.75 }}
          >
          Heat Treatment Solutions
        </HeaderTitleHighlight>
      </HeaderTitle>
      <HeaderImage as={motion.img} variants={{
        hidden: {opacity: 0, x: 150},
        visible: {opacity: 1, x: 0},
      }}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.75, delay: 1.25 }}
        src={header1} />

      
    </HeaderContainer>
  )
}

export default Header

const HeaderContainer = styled.div`
  margin: 0 0 0 8rem;

  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  min-height: 56vh;
  
  @media(max-width: 1282px){
    margin-left: 7.5rem;
  }

  @media(max-width: 900px){
    margin-left: 5rem;
    flex-direction: column;
  }

  

`

const HeaderTitle = styled.h1`
  font-size: 7rem;
  width: 65%;
  font-family: var(--font-primary);
  font-weight: 700;
  
  @media(max-width: 1282px){
      font-size: 5rem;
      width: 38%;
  }

  @media(max-width: 1050px){
      font-size: 4.5rem;
      width: 38%;
  }

  @media(max-width: 1000px){
      font-size: 6rem;
      width: 100%;
  }

  @media(max-width: 740px){
      font-size: 6rem;
  }

  @media(max-width: 550px){
      font-size: 5rem;
      width: 90%;
  }

  @media(max-width: 490px){
      font-size: 3.8rem;
      width: 90%;
  }

  @media(max-width: 400px){
      font-size: 3.7rem;
      width: 90%;
  }
`

const HeaderTitleHighlight = styled.span`
  color: #F2B705;
`


const HeaderImage = styled.img`
  width: 27%;
  margin-right: 10rem;

  border-radius: 1rem;

  @media(max-width: 1000px){
    width: 50%;
    margin-top: 2rem;
    margin-right: 2rem;
    }
`



